// @flow

import React from 'react';
import EmbeddedUrlPage from './embeddedurl/EmbeddedUrlPage';
import { embeddedUrlPage } from '../../../const';

function FinanceInvestorsEmbeddedUrl() {
  return (
    <EmbeddedUrlPage
      pageName={embeddedUrlPage.investor}
      cssClass="finance"
    />
  );
}

export default FinanceInvestorsEmbeddedUrl;
